class BusinessMarker {
    constructor(LatLngPosition, icons = []) {
        this.position = LatLngPosition;
        this.icons = icons;
        this.div = document.createElement("div");
        this.overlay = new google.maps.OverlayView();

        this.div.style.pointerEvents = "auto";

        this.overlay.onAdd = this.onAdd.bind(this);
        this.overlay.draw = this.draw.bind(this);
        this.overlay.onRemove = this.remove.bind(this);
    }

    addListener(action, callback){
        this.div.addEventListener(action, callback);
    }

    setMap(map) {
        this.overlay.setMap(map);
    }

    onAdd() {
        this.div.className = "businessMarker";

        // Добавляем иконки внутрь маркера
        this.icons.forEach((iconSrc) => {
            const iconImg = document.createElement("img");
            iconImg.className = 'businessMarker-icon';
            iconImg.classList.add('svgBlackToWhite');
            iconImg.src = iconSrc;
            this.div.appendChild(iconImg);
        });

        const panes = this.overlay.getPanes();
        panes.overlayMouseTarget.appendChild(this.div);
    }

    remove() {
        if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    }

    draw() {
        if (!this.div) return;
        const position = this.overlay.getProjection().fromLatLngToDivPixel(this.position);
        if (position) {
            this.div.style.left = `${position.x - this.div.offsetWidth / 2}px`;
            this.div.style.top = `${position.y - this.div.offsetHeight - 8}px`;
        }
    }

    getPosition() {
        return this.position;
    }

    getMarkerElement() {
        return this.div;
    }
}

export default BusinessMarker;
